import styled from "styled-components";
import { NavLink } from 'react-router-dom';

import {
  OFFICE_SERVERS__ROOT,
  FINALITY_LOGS__ROOT
} from "../../Routes";

import { ScreenSize, SIDEBAR_WIDTH, SIDEBAR_WIDTH_XL } from "../../../styling/constants";

import { ReactComponent as ServerIcon } from './server-icon.svg';
import { ReactComponent as LogsIcon } from './logs-icon.svg';


const Container = styled.div`
  width: ${SIDEBAR_WIDTH}px;
  background-color: #00425f;
  height: 100%;
  padding: 20px 15px;
  box-sizing: border-box;

  @media (min-width: ${ScreenSize.XL}px) {
    width: ${SIDEBAR_WIDTH_XL}px;
  }
`;

const MenuSectionHeader = styled.div`
  height: 40px;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding-left: 15px;
  margin-bottom: 5px;

  h6 {
    font-size: 1.2rem;
    letter-spacing: 1px;
    color: #ffffffa1;
  }
`;

const MenuItem = styled.div``;


export const StyledNavLink = styled(NavLink).attrs({
  activeClassName: 'active'
})`
  display: inline-block;
  width: 100%;
  text-decoration: none;
  margin-bottom: 10px;
  border-radius: 5px;

  &.active {
    background-color: white;
    transition: background-color 0.1s linear;
  }
`;

export const RouteItem = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 45px;
  padding-left: 15px;
  

  svg {
    width: 16px;
    height: 16px;
    margin-right: 10px;
  }

  svg path {
    fill: white;
  }

  p {
    display: inline-block;
    font-size: 1.4rem;
    font-weight: 500;
    color: white;
  }

  ${StyledNavLink}.active & {
    p {
      color: #00425f;
      font-weight: bold;
    }

    svg path {
      fill: #00425f;
    }
  }
`;

export default function Sidebar() {
  return (
    <Container>

      <StyledNavLink to={OFFICE_SERVERS__ROOT}>
        <RouteItem>
          <ServerIcon />
          <p>Office Servers</p>
        </RouteItem>
      </StyledNavLink>

      <StyledNavLink to={FINALITY_LOGS__ROOT}>
        <RouteItem>
          <LogsIcon />
          <p>Finality Logs</p>
        </RouteItem>
      </StyledNavLink>

    </Container>
  );
}